module.exports = __webpack_public_path__ + "static/img/idCardReverse.c0ef5da.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/idCardReverse.jpg
// module id = /Rcn
// module chunks = 1